import { lazy } from 'react';

import { loadUser } from '../../utils';

export const hideSplashScreen = () => {
  const splashScreenContainer = document.getElementById('splash_screen');
  const parent = splashScreenContainer && splashScreenContainer.parentNode;
  if (parent) {
    parent.removeChild(splashScreenContainer);
  }
};

export const handleBranchData = (branchData, history) => {
  if (!branchData) return;
  const {
    $deeplink_path,
    person,
    source,
    email,
    phone_number,
    token,
    uid,
    objectId,
  } = branchData;

  if (!$deeplink_path) return;

  let redirectPath;
  let redirectState;

  switch ($deeplink_path) {
    case 'signup': {
      if (loadUser()?.id === person) {
        redirectPath = '/';
      } else {
        redirectPath = '/signup';
        redirectState = {
          person,
          source,
          username: source,
          email,
          phone_number,
        };
      }
      break;
    }
    case 'service_request':
      redirectPath = `/service-requests/${objectId}`;
      break;
    case 'service_request_update':
      redirectPath = `/service-requests/${objectId}`;
      break;
    case 'service_request_feedback':
      redirectPath = `/service-requests/${objectId}`;
      break;
    case 'delivery':
      redirectPath = `/deliveries/list?id=${objectId}`;
      break;
    case 'visitor':
      redirectPath = `/visitors`;
      break;
    case 'visitor_log':
      redirectPath = `/visitors/log/?visitor=${objectId}`;
      break;
    case 'thread':
      redirectPath = `/messages`;
      break;
    case 'notification_preferences':
      redirectPath = '/notification-preferences';
      break;
    case 'passwordresetcomplete':
      redirectPath = `/password-reset?token=${token}&uid=${uid}`;
      break;
    default:
      redirectPath = '/';
  }

  history.push(redirectPath, redirectState);
};

export const lazyImport = (componentImport, componentName) =>
  lazy(async () => {
    const name = `retry-${componentName}`;
    const isRefreshed = JSON.parse(
      window.sessionStorage.getItem(name) || 'false',
    );

    try {
      const component = await componentImport();
      window.sessionStorage.setItem(name, 'false');
      return component;
    } catch (error) {
      if (!isRefreshed) {
        window.sessionStorage.setItem(name, 'true');
        return window.location.reload();
      }
      throw error;
    }
  });
